var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#999999",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{display:none;} "), /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "etc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "knife"
  }), /*#__PURE__*/React.createElement("g", {
    id: "emergency_meeting"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Suspicious"
  }), /*#__PURE__*/React.createElement("g", {
    id: "report"
  }), /*#__PURE__*/React.createElement("g", {
    id: "killed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,17v-2c0-1.103-0.8975-2-2-2h-1h-4h-9.7618c-0.8083-1.2047-2.1815-2-3.7382-2c-1.6338,0-3.053,0.884-3.8415,2.19 C3.5009,13.7906,2,15.7504,2,18v4c0,2.7568,2.2432,5,5,5h2v1c0,1.6543,1.3457,3,3,3h9c1.6543,0,3-1.3457,3-3v-1h3h1 c1.1025,0,2-0.897,2-2v-2c0-1.103-0.8975-2-2-2h-2.0728c-0.0948-0.7364-0.2717-1.4313-0.4576-2H28C29.1025,19,30,18.103,30,17z M7,15.5C7,14.1216,8.1211,13,9.5,13s2.5,1.1216,2.5,2.5v4c0,1.3784-1.1211,2.5-2.5,2.5S7,20.8784,7,19.5V15.5z M22,28 c0,0.5513-0.4482,1-1,1h-9c-0.5518,0-1-0.4487-1-1v-1h11V28z M23.0062,18.0306c0.0018,0.0657,0.024,0.1288,0.0392,0.1942 c0.0154,0.0651,0.0237,0.1315,0.0511,0.191c0.0045,0.0098,0.0032,0.0203,0.008,0.03C23.1143,18.4639,24,20.27,24,22 c0,0.5522,0.4473,1,1,1h3v2h-1h-4H10H7c-1.6543,0-3-1.3457-3-3v-4c0-0.8759,0.381-1.6773,1-2.2327V19.5C5,21.9814,7.0186,24,9.5,24 s4.5-2.0186,4.5-4.5v-4c0-0.1712-0.0318-0.3337-0.0505-0.5H23h4h1v2h-4c-0.0114,0-0.0208,0.0061-0.032,0.0065 c-0.0591,0.0019-0.1161,0.0226-0.1752,0.0353c-0.0726,0.0159-0.1458,0.0259-0.2115,0.0565 c-0.0087,0.004-0.018,0.0029-0.0266,0.0071c-0.0411,0.0204-0.0673,0.056-0.1042,0.0811c-0.0642,0.0435-0.1285,0.0839-0.1809,0.1408 c-0.041,0.0446-0.0672,0.0965-0.0992,0.1471c-0.0366,0.0576-0.0755,0.1114-0.0999,0.1761c-0.0244,0.0648-0.03,0.1324-0.0406,0.201 C23.0221,17.9021,23,17.9474,23,18C23,18.0109,23.0058,18.0198,23.0062,18.0306z M20.293,7.293L20.5859,7l-0.293-0.293 c-0.3906-0.3906-0.3906-1.0234,0-1.4141s1.0234-0.3906,1.4141,0L22,5.5859l0.293-0.293c0.3906-0.3906,1.0234-0.3906,1.4141,0 s0.3906,1.0234,0,1.4141L23.4141,7l0.293,0.293c0.3906,0.3906,0.3906,1.0234,0,1.4141C23.5117,8.9023,23.2559,9,23,9 s-0.5117-0.0977-0.707-0.293L22,8.4141l-0.293,0.293C21.5117,8.9023,21.2559,9,21,9s-0.5117-0.0977-0.707-0.293 C19.9023,8.3164,19.9023,7.6836,20.293,7.293z M15,11h3.427c1.0298,0.6371,2.2766,1,3.573,1c3.3086,0,6-2.2432,6-5s-2.6914-5-6-5 s-6,2.2432-6,5v0.5859l-1.707,1.707c-0.2861,0.2861-0.3721,0.7158-0.2168,1.0898C14.2305,10.7563,14.5957,11,15,11z M17.7064,8.7077c0.0925-0.0923,0.1658-0.2031,0.2166-0.3258C17.9735,8.2598,18,8.1301,18,8V7c0-1.6543,1.7939-3,4-3s4,1.3457,4,3 s-1.7939,3-4,3c-1.0146,0-1.9844-0.29-2.7295-0.8164c-0.2002-0.141-0.4335-0.1855-0.6596-0.1667C18.5819,9.0143,18.557,9,18.5273,9 h-1.1133L17.7064,8.7077z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Die_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pets"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Die_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ghost"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hats"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Crewmates"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ejection"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sabotage"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Die"
  }), /*#__PURE__*/React.createElement("g", {
    id: "impostor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pets"
  }), /*#__PURE__*/React.createElement("g", {
    id: "crewmates"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVent);
export default __webpack_public_path__ + "static/media/vent.8785719c51a5a54bd0bb53d7df8915a8.svg";
export { ForwardRef as ReactComponent };